/* 3774 - Facetory - UX PDP Redesign Deployment - By: Uzma Jafar - START */

jQuery(document).ready(function($){
  /* Accordions on PDP */
  $('.accordion-item-span').on('click', function(){
    $(this).parent('li').siblings('li').removeClass('active').find('.accordion-content').slideUp();
    $(this).parent('li').toggleClass('active').find('.accordion-content').slideToggle();
  
    if($(this).parent('li').hasClass('active')) {
      $('.product-aside').css({'position': 'relative'});
      setTimeout(() => {
        $('html, body').animate({ scrollTop: $(this).parent('li.active').find('.accordion-content').offset().top - (160)  }, 1500);
      }, 500);
    } else {
      // $('.product-aside').css({'position': 'sticky'});
    }
  });

  /* Clone package dropdown */
  if($('#ProductSelect-product-template option').length > 1) {
      $('.custom-select-product-varient').html($('#ProductSelect-product-template').clone().attr('id', 'ProductSelect-product-template-2').addClass('custom-varient-dropdown')).show();
  }

  /* Clone/Update price in second "Add to Cart" button */
  var new_price = $('#ProductPrice-product-template').text().split(" ");
  $('#ProductPrice-product-template-2').text(new_price[0]);
  $("body").on('DOMSubtreeModified', "#ProductPrice-product-template", function() {
      var new_price = $(this).text().split(" ");
      $('#ProductPrice-product-template-2').text(new_price[0]);
  });

  /* Clone/Update quantity in then second "Quantity" field */
  $("body").on('click', ".adjust.adjust-minus, .adjust.adjust-plus", function() {
      var input_quantity = $(this).parents('.quantity-select').find('input.quantity').val();
      if($(this).closest('form.shopify-product-form').length > 0) {
          $('#Quantity-product-template-2').val(input_quantity);
      } else {
          $('#Quantity-product-template').val(input_quantity);
      }
  });
  
  /* Convert radio buttons to select dropdown */
  var rc_select_once = false;
  var rc_select_counter = 0;
  $("body").on('DOMSubtreeModified', "#rc_container", function() {
      
      if($('#rc_container .rc_radio').length < 2) {
          $('.custom-select-product-subscription').hide();
      } else {
          if(++rc_select_counter == 3) {
              rc_select_once = true;
          }

          if(rc_select_once) {
              // Create a select:
              var $select = $('<select class="custom-subscription-dropdown" />');

              //Get Exising Select Options    
              $('.rc_block__type').each(function(){
                  var $radio = $(this);
                  var $option = $('<option />');
                  if($radio.find('.rc_label')[1]) {
                      if($radio.find('.rc_label__frequency')[0]) {
                        $option.attr('value', $radio.find('.rc_radio')[0].value).text($radio.children('.rc_label')[0].innerText + ' - ' + $radio.find('.rc_label__delivery')[0].innerText + ': ' + $radio.find('.rc_label__frequency')[0].innerText);
                      } else {
						$option.attr('value', $radio.find('.rc_radio')[0].value).text($radio.children('.rc_label')[0].innerText);                        
                      }
                  } else {
                      $option.attr('value', $radio.find('.rc_radio')[0].value).html($radio.children('.rc_label')[0].innerText);
                  }
                  $select.append($option);
              });

              $('.custom-subscription-dropdown').replaceWith($select);
              $('.custom-select-product-subscription').show();

              rc_select_once = false;
          }
          
      }
  
  });

  $('body').on('change', '.custom-subscription-dropdown, .rc_radio', function(e){
      var valueAttribute = '[value="' + e.target.value + '"]';

      $('.rc_block__type').removeClass('rc_block__type--active');

      $('.custom-subscription-dropdown option' + valueAttribute).prop('selected', true);
      $('.rc_radio' + valueAttribute).prop('checked', true).parent('.rc_block__type').addClass('rc_block__type--active');
      $('.rc_radio' + valueAttribute + ':checked').trigger('click');
  });

  $('body').on('change', '.custom-varient-dropdown, .single-option-selector__radio', function(e){
      var $element = $(e.target);
      
      if ($element.is(':radio')) {
          $('.custom-varient-dropdown option:contains(' + $element.val() + ')').prop('selected', true);
          window.history.replaceState(null, null, "?variant="+$('.custom-varient-dropdown option:selected').val());
      } else {
          var optionSelected = $("option:selected", this);

          var selectedOptionValues = optionSelected.text().split("-");
          var valueAttribute = '[value="' + $.trim(selectedOptionValues[0]) + '"]';

          window.history.replaceState(null, null, "?variant="+$element.val());
          
          $('.single-option-selector__radio' + valueAttribute).prop('checked', true);
          $('.single-option-selector__radio' + valueAttribute + ':checked').parent('.swatch-container').trigger('click');
          $('#ProductSelect-product-template option[value="' + $element.val() + '"]').prop('selected', true);

      }

  });

  /* Sticky Bar - START */ 

  stickyElemTarget = document.querySelector(".product-aside");
  stickyElem = document.querySelector(".bws-addtocart-wrapper");
  
  // Declare globally delayed listener
  var resize_timeout;
  $(window).on('resize orientationchange', function(){
      clearTimeout(resize_timeout);

      resize_timeout = setTimeout(function(){
          $(window).trigger('resized');
      }, 500);
  });

  function measureStickyElementHeight() {
      if(window.innerWidth > 768) {
        currStickyPos = stickyElemTarget.getBoundingClientRect().bottom + window.pageYOffset - window.innerHeight + 600;
      } else {
        currStickyPos = stickyElem.getBoundingClientRect().bottom + window.pageYOffset - window.innerHeight;
      }
    }
  measureStickyElementHeight();

  function bwsATCStickybar() {
    if (window.pageYOffset > currStickyPos) { 
      stickyElem.classList.add('fixed-sticky-bar');
    } else { 
      stickyElem.classList.remove('fixed-sticky-bar');
    } 
  }
  $(window).on('resized', function (){
    stickyElem.classList.remove('fixed-sticky-bar');
    measureStickyElementHeight();
    bwsATCStickybar();
  });
  $(window).on('scroll', function (){
    bwsATCStickybar();
  });

  /* Sticky Bar - END */ 

  // ATC Back to top on PDP
  $('.custom-addtocart-up-arrow').on('click', function(){
    $([document.documentElement, document.body]).animate({
      scrollTop: $('.product-aside').offset().top - 90
  }, 300);
  });

  // Add to Cart
  $('#AddToCart-product-template-2').on('click', function(){
    $('.shopify-product-form').submit();
  });

});

/* 3774 - Facetory - UX PDP Redesign Deployment - By: Uzma Jafar - END */